import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import posthog from 'posthog-js'

export const ClientAnalyticsPageView = () => {
  const location = useLocation()

  // Track pageviews
  useEffect(() => {
    if (posthog.has_opted_out_capturing()) return

    posthog.capture('$pageview', {
      $current_url: window.location.href,
    })
  }, [location])

  return null
}
